
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/healthcare-software-development-services",
      function () {
        return require("private-next-pages/healthcare-software-development-services.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/healthcare-software-development-services"])
      });
    }
  